module.exports = __webpack_public_path__ + "static/media/STATIC.bdaf5094.png";